import React, { useState } from 'react'
import InfoNavItem from '../atoms/InfoNavItem' // fixed import path {Muyiwa}

const InfoNav = (props) => {
  const [selected, setSelected] = useState("")

  return (
    <div className={`flex flex-col gap-2 ${props.navStyle}`}>
    { props.navData.map(item => (
        <InfoNavItem
          title={item.title}
          active={item.title === selected}
          link={`${props.navPath}${item.link}`}
          onClick={e => setSelected(e.target.dataset.name)}
          key={item.title} // unique key for each item added by {Muyiwa}
        />
    ))}
    </div>
  )
}

export default InfoNav